enum Constants {
  /** Number of results to download per retrieval, used in various places */
  ResultCount = 50,
  HeaderHideBreakpoint = 90,
  // The OneDrive client id used to be commented out here, which was only ever
  // misleading - it is not read from this file and never was. Every provider
  // keeps its own credentials next to its own auth code:
  //   Google   - services/gapi/gapiService.tsx  (clientId, apiKey)
  //   OneDrive - services/oneDrive/oneDriveAuth.ts  (msalConfiguration)
  //   Dropbox  - services/dropbox/dropboxAuth.ts  (appKey)
  MsGraphDlUrlProp = '@microsoft.graph.downloadUrl',
  DataFolder = 'Fadila',
  ActivePlaylistName = '♫ Now Playing ♫',
  ActivePlaylistId = 'activeplaylist',
  /** LocalStorage key */
  ActivePlaylistKey = 'activePlaylist',
  LibraryName = '📚 Library',
  LibraryId = 'library',
  PodcastFolderName = 'Podcasts',
  NewPlaylistName = '» New Playlist «',
}
export default Constants;

export enum Tasks {
  addFolderToPlaylist = 'addFolderToPlaylist',
  resetAppDataFolder = 'resetAppDataFolder',
  downloadAppDataFolder = 'downloadAppDataFolder',
}
export enum Keys {
  saved,
  storageProviderNotLoggedIn,
  dropboxNotLoggedIn,
  spotifyNotLoggedIn,
  googleAppDataDuplicates,
  libraryPathNotConfigured,
  libraryLoadError,
  ensurePathStringConformity,
  notPodcastItem,
  savedPodcastItem,
  playlistNotFound,
  errorAddingPlaylistToLibrary,
  errorAddingFolderToLibrary,
  invalidTrackType,
  driveRequiresServiceWorker,
  googleSignInDidNotComplete,
  googleScopeNotGranted,
  driveFilesPermissionMissing,
}
const strings: {
  [P in Keys]: string;
} = {
  [Keys.dropboxNotLoggedIn]: 'Please log in to Dropbox and try again',
  [Keys.spotifyNotLoggedIn]: 'Please log in to Spotify and try again',
  [Keys.storageProviderNotLoggedIn]: 'You have not authenticated with your currently configured storage provider. Please log in.',
  [Keys.libraryPathNotConfigured]: 'Please configure library path in settings',
  [Keys.ensurePathStringConformity]: 'Path string should start with /',
  [Keys.saved]: 'Saved!',
  [Keys.notPodcastItem]: 'Incorrect track type, podcast item needed',
  [Keys.savedPodcastItem]: 'Successfully saved podcast to library, updated all playlists with saved item',
  [Keys.googleAppDataDuplicates]: 'Duplicate app data files found! Reset GoogleDrive AppData in settings may fix. Please notify fadila@starcraft.is.',
  [Keys.playlistNotFound]: 'Unable to find playlist, please try again.',
  [Keys.errorAddingPlaylistToLibrary]: 'Error adding playlist to library',
  [Keys.errorAddingFolderToLibrary]: 'Error adding folder to library',
  [Keys.libraryLoadError]: 'Unable to load library, please reload to try again',
  [Keys.invalidTrackType]: 'Invalid track type, can\'t add to library',
  [Keys.driveRequiresServiceWorker]: 'Google Drive is unavailable on this device: the background worker that authorises Drive downloads could not start. Other storage providers still work. On iOS, try Safari, add the app to your home screen, and ensure private browsing is off.',
  [Keys.googleSignInDidNotComplete]: 'Google sign-in did not complete. The sign-in window closed without establishing a session, which is what normally happens on iOS: Safari blocks the cross-site cookie the old Google sign-in library depends on. Google Drive cannot be used as the storage provider on this device.',
  [Keys.googleScopeNotGranted]: 'Signed in to Google, but the permission Fadila needs was not granted. Without it the library cannot be stored in your Drive.',
  [Keys.driveFilesPermissionMissing]: 'Signed in to Google, but Fadila has not been given permission to read your Drive files - only its own settings folder. Open Google Drive from the menu and press the sign-in button there to grant it.',
};

export function messages(key: Keys) {
  
  return strings[key];
}

/**
 * Tests for a mac desktop computer.
 * This is used to make assumptions on intended use of ctrlKey and metakey.
 * We switch shortcuts on mac computers.
 */
export const isMac = /mac/i.test(navigator.platform);

export const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

export const backendHost = () => process.env.NODE_ENV === 'production'
  ? 'https://fadilabackend.azurewebsites.net/api'
  : 'https://fadilabackenddev.azurewebsites.net/api'
  ;

  /** 
   * Default character to use for width calculations
   * F.x. when calculating default width of columns with calcFromCharCount
   * render an element filled with x * characterForWidthCalc
   */
export const characterForWidthCalc = '0';
